import {IBaseLookup} from "./Ibase.lookup";

export namespace AvailabilityIndicator {

    export const lookupName: string = "AvailabilityIndicator";

    export interface AvailabilityIndicator {
        availabilityIndicatorKey: number;
        code: string;
        description: string;
        color: string;
        allowDaysInAdvance: number;
        lastUpdated: Date;
        alternateColor: string;
        defaultSearch: string;
        allowNNextDays: number;
    }

    export interface AvailabilityIndicatorDS extends IBaseLookup {
        availabilityIndicator: AvailabilityIndicator[];
    }
}
